import Button from "@/components/Button";
import Dialog from "@/components/Dialog";

export function SetOrderDraftBlockedModal({ onDismiss }: { onDismiss: () => void }) {
  const actions = (
    <div className="flex justify-end gap-2 mt-4">
      <Button onClick={onDismiss}>Dismiss</Button>
    </div>
  );

  return (
    <Dialog onClosed={onDismiss} open actions={actions} headline="Order Cannot Be Set to Draft">
      <p>
        This order has historical payments. Only canceled orders without historical payments can be set back to draft
        status.
      </p>
    </Dialog>
  );
}
